<template>
    <div class="page" v-if="isDataLoaded">
        <HeadKf></HeadKf>
        <div class="b1">
            <p class="f-fc2 f-fs16 f-fwb">{{ detail.isEvaluate == 1 ? '已评价' : detail.processingStatus }}</p>
            <p class="f-fc2 f-fs14 mt-25" v-if="detail.isEvaluate == 1">感谢你的反馈，期待下一次为您服务</p>
            <p class="f-fc2 f-fs14 mt-25" v-else-if="detail.processingStatus == '已完成'">工单已完成，请您评价</p>
            <p class="f-fc2 f-fs14 mt-25" v-else>工单正在处理中，请您耐心等待</p>
        </div>
        <div class="b2">
            <p class="f-fwb f-fc1 f-fs14 head">订单编号：{{ detail.orderNo }}</p>
            <div class="list" data-flex="cross:center">
                <p class="tit" data-flex-box="1">服务类型：</p>
                <p class="txt f-fc6">
                    <template v-if="detail.type == 1">上门服务</template>
                    <template v-else-if="detail.type == 2">返厂维修</template>
                    <template v-else-if="detail.type == 3">预约巡检</template>
                    <template v-else-if="detail.type == 4">申请延保</template>
                    <template v-else-if="detail.type == 5">直播申请</template>
                    <template v-else-if="detail.type == 6">在线报障</template>
                    <template v-else-if="detail.type == 7">预约培训</template>
                    <template v-else-if="detail.type == 8">预约调试</template>
                    <template v-else-if="detail.type == 9">业务咨询</template>
                </p>
            </div>
        </div>
        <div class="b3">
            <template v-if="detail.type == 1 || detail.type == 2">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">用户名称：</p>
                    <p class="txt1 f-fc8">{{ detail.userName }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">用户联系人：</p>
                    <p class="txt1 f-fc8">{{ detail.userContacts }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">用户联系电话：</p>
                    <p class="txt1">{{ detail.userPhone }}</p>
                </div>
            </template>
            <!-- 1上门服务 2返厂维修 3预约巡检 4申请延保 5直播申请 6在线报障 7预约培训 8预约调试 9业务咨询 -->
            <!-- 1上门服务 -->
            <template v-if="detail.type == 1">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">报障日期：</p>
                    <p class="txt1">{{ detail.date }}</p>
                </div>
                <div class="list" data-flex="cross:top">
                    <p class="tit f-fs14" data-flex-box="1">故障主诉：</p>
                    <p class="txt1">{{ detail.fault }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">省 份：</p>
                    <p class="txt1">{{ detail.province }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">城 市：</p>
                    <p class="txt1">{{ detail.cities }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">区 / 县：</p>
                    <p class="txt1">{{ detail.regions }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">跟进技术：</p>
                    <p class="txt1 f-fc8">{{ detail.technician }}</p>
                </div>
            </template>
            <!-- 2返厂维修 -->
            <template v-if="detail.type == 2">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">设备到厂日期：</p>
                    <p class="txt1">{{ detail.date }}</p>
                </div>
            </template>
            <!-- 3预约巡检 -->
            <template v-if="detail.type == 3">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">用户名称：</p>
                    <p class="txt1 f-fc8">{{ detail.userName }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">电话</p>
                    <p class="txt1">{{ detail.userPhone }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">联系人</p>
                    <p class="txt1 f-fc8">{{ detail.contacts }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">服务地区：</p>
                    <p class="txt1">{{ detail.address }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">期望服务时间：</p>
                    <p class="txt1 f-fc8">{{ detail.doorTime }}</p>
                </div>
            </template>
            <!-- 4申请延保 -->
            <template v-if="detail.type == 4">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">您的称呼：</p>
                    <p class="txt1 f-fc8">{{ detail.userName }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">您的手机号码：</p>
                    <p class="txt1">{{ detail.userPhone }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">您所在省份：</p>
                    <p class="txt1">{{ detail.address }}</p>
                </div>
                <div class="list">
                    <p class="tit f-fs14" data-flex-box="1">您所在单位/学校/公司名称：</p>
                    <p class="txt1 mt-10">{{ detail.contacts }}</p>
                </div>
                <div class="list">
                    <p class="tit f-fs14" data-flex-box="1">您的服务需求：</p>
                    <p class="txt1 mt-10">{{ detail.fault }}</p>
                </div>
            </template>
            <!-- 5直播申请 -->
            <template v-if="detail.type == 5">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">用户名称：</p>
                    <p class="txt1 f-fc8">{{ detail.userName }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">电话：</p>
                    <p class="txt1">{{ detail.userPhone }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">联系人：</p>
                    <p class="txt1 f-fc8">{{ detail.contacts }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <div class="tit f-fs14" data-flex-box="1">
                        设备租赁：
                        <p class=" f-fc12 f-fs12 mt-10">直播是否需要租赁设备</p>
                    </div>
                    <p class="txt1 mt-10">{{ detail.isLease }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <div class="tit f-fs14" data-flex-box="1">
                        技术支撑：
                        <p class=" f-fc12 f-fs12 mt-10">直播是否需要技术人员现场支持</p>
                    </div>
                    <p class="txt1 mt-10">{{ detail.fault }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <div class="tit f-fs14" data-flex-box="1">
                        云服务：
                        <p class=" f-fc12 f-fs12 mt-10">直播是否需要购买流量</p>
                    </div>
                    <p class="txt1 mt-10">{{ detail.isCloud }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">服务地区：</p>
                    <p class="txt1">{{ detail.address }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">期望服务时间：</p>
                    <p class="txt1">{{ detail.doorTime }}</p>
                </div>

            </template>
            <!-- 6在线报障 -->
            <template v-if="detail.type == 6">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">用户名称：</p>
                    <p class="txt1 f-fc8">{{ detail.userName }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">电话：</p>
                    <p class="txt1">{{ detail.userPhone }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">联系人：</p>
                    <p class="txt1 f-fc8">{{ detail.contacts }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">所在地：</p>
                    <p class="txt1">{{ detail.address }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">故障现象描述：</p>
                    <p class="txt1">{{ detail.fault }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">产品型号：</p>
                    <p class="txt1">{{ detail.unitType }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">产品机身号：</p>
                    <p class="txt1">{{ detail.deviceNo }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">技服是否知晓故障情况：</p>
                    <p class="txt1">{{ detail.gzqk }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">您的身份：</p>
                    <p class="txt1">{{ detail.identity }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">收件地址：</p>
                    <p class="txt1">{{ detail.shippingAddress }}</p>
                </div>
            </template>
            <!-- 7预约培训 -->
            <template v-if="detail.type == 7">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">用户名称：</p>
                    <p class="txt1 f-fc8">{{ detail.userName }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">电话：</p>
                    <p class="txt1">{{ detail.userPhone }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">联系人：</p>
                    <p class="txt1 f-fc8">{{ detail.contacts }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">培训对象：</p>
                    <p class="txt1 f-fc8">{{ detail.ywType }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">设备型号：</p>
                    <p class="txt1">{{ detail.unitType }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">服务地区：</p>
                    <p class="txt1">{{ detail.address }}</p>
                </div>
                <div class="list">
                    <p class="tit f-fs14" data-flex-box="1">培训内容：</p>
                    <p class="txt1 mt-10">{{ detail.fault }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">期望服务时间：</p>
                    <p class="txt1">{{ detail.doorTime }}</p>
                </div>
            </template>
            <!-- 8预约调试 -->
            <template v-if="detail.type == 8">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">用户名称：</p>
                    <p class="txt1 f-fc8">{{ detail.userName }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">电话：</p>
                    <p class="txt1">{{ detail.userPhone }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">联系人：</p>
                    <p class="txt1 f-fc8">{{ detail.contacts }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">服务地区：</p>
                    <p class="txt1">{{ detail.address }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">调试类型：</p>
                    <p class="txt1">{{ detail.ywType }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">期望服务时间：</p>
                    <p class="txt1">{{ detail.doorTime }}</p>
                </div>

            </template>
            <!-- 9业务咨询 -->
            <template v-if="detail.type == 9">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">用户名称：</p>
                    <p class="txt1 f-fc8">{{ detail.userName }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">单位电话：</p>
                    <p class="txt1 f-fc8">{{ detail.userPhone }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">姓名：</p>
                    <p class="txt1 f-fc8">{{ detail.contacts }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">咨询业务类型：</p>
                    <p class="txt1 f-fc8">{{ detail.ywType }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">所在地：</p>
                    <p class="txt1">{{ detail.address }}</p>
                </div>

            </template>
        </div>
        <div class="b3">
            <!-- 1上门服务 2返厂维修 -->
            <template v-if="detail.type == 1 || detail.type == 2">
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">设备名称：</p>
                    <p class="txt1">{{ detail.deviceName }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">设备型号：</p>
                    <p class="txt1">{{ detail.unitType }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">机身号码：</p>
                    <p class="txt1">{{ detail.deviceNo }}</p>
                </div>
            </template>
            <template v-if="detail.type == 2">
                <div class="list">
                    <p class="tit f-fs14" data-flex-box="1">故障主诉：</p>
                    <p class="txt1 mt-10">{{ detail.fault }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">跟进技术：</p>
                    <p class="txt1 f-fc8">{{ detail.technician }}</p>
                </div>
                <div class="list" data-flex="cross:center">
                    <p class="tit f-fs14" data-flex-box="1">解决方案：</p>
                    <p class="txt1">{{ detail.solution }}</p>
                </div>
            </template>
            <!-- 2返厂维修 -->
        </div>
        <div class="b3">
            <template v-if="detail.type == 1">
                <div class="list">
                    <p class="f-fs14 f-fwb mb-10" data-flex-box="1">现场故障现象：</p>
                    <p class="f-fc12  f-fs12">{{ detail.actualFault }}</p>
                </div>
                <div class="list">
                    <p class="f-fs14 f-fwb mb-10" data-flex-box="1">现场解决措施：</p>
                    <p class="f-fc12  f-fs12">{{ detail.solutions }}</p>
                </div>
            </template>
            <template v-if="detail.type == 2">
                <div class="list">
                    <p class="f-fs14 f-fwb mb-10" data-flex-box="1">处理状态：</p>
                    <p class="f-fc12  f-fs12">{{ detail.processingStatus }}</p>
                </div>
                <div class="list">
                    <p class="f-fs14 f-fwb mb-10" data-flex-box="1">处理结果：</p>
                    <p class="f-fc12  f-fs12">{{ detail.solutions }}</p>
                </div>
            </template>
        </div>
        <!-- 服务评价 -->
        <div class="b4" v-if="detail.isEvaluate == 1">
            <div class="f-fs16 f-fwb pb-20">服务评价</div>
            <template v-if="detail.type == 1">
                <div class="list">
                    <p class="f-fc12 f-fs12 mb-10" data-flex-box="1">您对技术人员响应速度或回复及时性是否满意？</p>
                    <p class="f-fc11 f-fs12">满意度：{{ detail.score1 }}分</p>
                </div>
                <div class="list">
                    <p class="f-fc12 f-fs12 mb-10" data-flex-box="1">您对技术人员上门的服务态度是否满意？</p>
                    <p class="f-fc11 f-fs12">满意度：{{ detail.score2 }}分</p>
                </div>
                <div class="list">
                    <p class="f-fc12 f-fs12 mb-10" data-flex-box="1">您对技术人员上门的服务专业性是否满意？</p>
                    <p class="f-fc11 f-fs12">满意度：{{ detail.score3 }}分</p>
                </div>
                <div class="list">
                    <p class="f-fc12 f-fs12 mb-10" data-flex-box="1">本次上门服务为您提供了哪些服务？</p>
                    <div class="provideService" v-if="!isEmpty(detail.provideService)">
                        <span v-for="item in detail.provideService">{{ item }}</span>
                    </div>
                </div>
            </template>

            <div class="list">
                <p class="f-fc12 f-fs12 mb-10" data-flex-box="1">本次服务进行综合评分</p>
                <p class="f-fc11 f-fs12">满意度：{{ detail.score }}分</p>
            </div>
            <div class="list">
                <p class="f-fc12 f-fs12 mb-10" data-flex-box="1">对奥威亚产品功能、应用、服务等方面有什么需求或建议?</p>
                <p class="f-fc11 f-fs12">{{ detail.propose }}</p>
            </div>
        </div>

        <div class="ops" data-flex="cross:center">
            <span data-flex-box="1"></span>
            <div class="s1" hover-class="none" @click="toLink('https://im7a2314e.7x24cc.com/fu_u2x7lgvmse')"
                data-flex-box="0">
                问题反馈</div>
            <div v-if="detail.processingStatus == '已完成' && detail.isEvaluate != 1" class="s2" hover-class="none"
                @click="funEvaluate(detail.type, { orderId: detail.id })" data-flex-box="0">
                服务评价</div>
            <div class="s3" hover-class="none" @click.stop="toHome('/')" data-flex-box="0">
                重新下单</div>
        </div>
        <Evaluate></Evaluate>
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, Field, CheckboxGroup, Checkbox } from 'vant'
import MgPopup from '@/components/common/mg-popup'
import Evaluate from '@/components/common/evaluate'
import HeadKf from '@/components/common/head-kf'

export default {
    mixins: [mix1],
    components: {
        [CheckboxGroup.name]: CheckboxGroup,
        [Checkbox.name]: Checkbox,
        [Button.name]: Button,
        [Field.name]: Field,
        Evaluate,
        HeadKf
    },
    data() {
        return {
            id: 0,
            tel: '',
            show: false,
            detail: {}
        }
    },
    methods: {
        // checked(e) {
        //     console.log(e)
        // },
        async getDetail() {
            console.log(this.id)
            const promise = this.apiGet('orders.del', { id: this.id })

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            if (this.isEmpty(apiResult)) {
                return
            }

            this.detail = apiResult.obj
            this.isDataLoaded = true
        },
        toHome(url) {
            this.$router.push(url)
        },
        bindMobile() { }

    },
    mounted() {

    },
    created() {
        let id = this.$route.query.id
        this.id = id
        this.getDetail()
    }
}
</script>

<style lang="less" scoped>
.page {
    padding-bottom: 150px;

    .b1 {
        background: #2F8BF0;
        padding: 30px;
        padding-bottom: 50px;
        box-sizing: border-box;
    }

    .b2 {
        background: #fff;
        border-radius: 10px 10px 0 0;
        margin-top: -20px;

        .tit {
            color: #B5B5B5;
        }

        .head {
            padding: 20px 30px;
            box-sizing: border-box;
            border-bottom: solid 1px #F9F5F5;
        }

        .list {
            padding: 30px;
            box-sizing: border-box;
            border-bottom: solid 1px #F9F5F5;

            .tit {
                min-width: 200px;
            }
        }
    }

    .b3 {
        background: #fff;
        margin-top: 20px;

        .tit {
            color: #B5B5B5;
        }

        .txt1 {
            color: #609FFA;
        }

        .list {
            padding: 30px;
            box-sizing: border-box;
            border-bottom: solid 1px #F9F5F5;

            .tit {
                min-width: 200px;
            }
        }
    }

    .b4 {
        margin-top: 20px;
        padding: 30px;
        box-sizing: border-box;
        background: #fff;

        .list {
            border: none;
            padding: 15px 0;
        }
    }

    .provideService {
        span {
            text-align: center;
            font-size: 12px;
            color: #fff;
            padding: 4px 8px;
            background: #D65E5E;
            border-radius: 4px;
            margin: 10px;
            display: inline-block;
        }
    }

    .ops {
        background: #fff;
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 20px 24px;
        box-sizing: border-box;

        span {
            font-size: 16px;
            color: #5bb637;

            &.on {
                color: #e84115;
            }
        }

        .s1,
        .s2,
        .s3 {
            width: 170px;
            border-radius: 100px;
            // padding: 10rpx 0;
            font-size: 14px;
            margin-left: 20px;
            text-align: center;
            line-height: 60px;
            border: solid 1px #B5B5B5;
            color: #B5B5B5;
        }

        .s2 {
            background: #205CFF;
            border: solid 1px #205CFF;
            color: #fff;
        }

        .s3 {
            background: #D65E5E;
            border: solid 1px #D65E5E;
            color: #fff;
        }
    }

    .content {
        padding: 30px;
        box-sizing: border-box;

        .tit {
            color: #B5B5B5;
        }

        .checked {
            width: 100%;
            display: inline-block;

            >div {
                float: left;
                width: 33.33%;
                margin: 20px 0px;
            }
        }

        .li {
            p {
                width: 54px;
                height: 54px;
                border: solid 1px #B5B5B5;
                border-radius: 4px;
                text-align: center;
                line-height: 54px;
                color: #B5B5B5;
                margin: 0 6px;
            }

            .on {
                background: #E8C767;
                border: solid 1px #E8C767;
                color: #fff;
            }
        }

        .inp {
            border: solid 1px #B9B9B9;
            width: 100%;
            margin: 0 auto;
            border-radius: 10px;
            margin-bottom: 40px;

            .van-cell {
                padding: 10px;
            }

            .van-cell::after {
                border: none;
            }
        }

        .btn {
            width: 100%;
            text-align: center;
            margin-top: 50px;

            button {
                background: #D65E5E;
                color: #fff;
                border-radius: 100px;
                border-color: #D65E5E;
                width: 225px;
                height: 68px;
                margin: 0 auto;
            }

        }
    }

}
</style>